import styled from 'styled-components';

export const CopyButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background-color: transparent;
  color: ${props => props?.hasCopied ? '#4BB543' : '#000'};
  border: ${props => props?.hasCopied ? '1px solid #4BB543' : '1px solid #000'};
  border-radius: 0.25rem;
  font-size: 1rem;
  padding: 0.5rem 1rem;
  transition: all 0.1s ease;
  cursor: pointer;
`;